const state = {
  confirm: null,
  snackbar: false,
  msg: '',
  color: 'firebrick',
  top: true,
  bottom: false,
  left: false,
  right: false,
  multiline: false,
  vertical: false,
  timeout: 6000
}

const getters = {
  getSnackbar: (state) => {
    const msg = {
      msg: state.msg,
      color: state.color,
      top: state.top,
      bottom: state.bottom,
      left: state.left,
      right: state.right,
      timeout: state.timeout,
      multiline: state.multiline,
      snackbar: state.snackbar,
      vertical: state.vertical
    }
    return msg
  }
}

const mutations = {
  setConfirm (state, value) {
    state.confirm = value
  },
  setSnackbar: (state, dados) => {
    let timeout
    let color
    let msg
    !dados.timeout ? timeout = 4000 : timeout = dados.timeout
    !dados.color ? color = 'firebrick' : color = dados.color
    !dados.msg ? msg = '' : msg = dados.msg

    if (!state.snackbar) {
      state.timeout = timeout
      state.color = color
      state.msg = msg
      state.snackbar = true
    }
    setTimeout(() => {
      state.snackbar = false
    }, timeout)
  }
}

const actions = {
  mostrarMsg: ({ commit }, mensagem) => {
    commit('setSnackbar', mensagem)
  }
}

export default { namespaced: true, state, mutations, actions, getters }
